import app from 'app';

app.component('gcTypeaheadOption', {
  bindings: {
    match: '<'
  },
  transclude: true,
  template: '<ng-transclude></ng-transclude>'
});
